import React from "react"
import { BikeLabelOrderIndexStepEnum } from "features/bikeLabelOrder/types"

//Export Lazy Step File
const OrderStep = React.lazy(() => import("./OrderStep/OrderStep"))
const SummaryStep = React.lazy(() => import("./SummaryStep/SummaryStep"))
const ConfirmationStep = React.lazy(() => import("./ConfirmationStep/ConfirmationStep"))
const ExpeditionStep = React.lazy(() => import("./ExpeditionStep/ExpeditionStep"))
const RedirectToCommandStep = React.lazy(() => import("./RedirectToCommandStep"))

type SwitchBikeLabelOrderStepProps = {
	step: `${BikeLabelOrderIndexStepEnum}`
	[key: string]: unknown
}

const SwitchBikeLabelOrderStep: React.FC<SwitchBikeLabelOrderStepProps> = ({ step, ...props }) => {
	switch (step) {
		case BikeLabelOrderIndexStepEnum.COMMAND_STEP:
			return <OrderStep {...props} />
		case BikeLabelOrderIndexStepEnum.EXPEDITION_STEP:
			return <ExpeditionStep {...props} />
		case BikeLabelOrderIndexStepEnum.SUMMARY_STEP:
			return <SummaryStep {...props} />
		case BikeLabelOrderIndexStepEnum.CONFIRMATION_STEP:
			return <ConfirmationStep {...props} />
		default:
			return <RedirectToCommandStep />
	}
}

export default SwitchBikeLabelOrderStep
